export const API_URL = process.env.REACT_APP_API_URL;
export const USER_URL = process.env.REACT_APP_AUTH_URL;
export const LOGIN_URL = `${process.env.REACT_APP_AUTH_URL}/Login`;
export const LOGOUT_URL = `${process.env.REACT_APP_AUTH_URL}/Logout`;

export const REACT_APP_ENV = process.env.REACT_APP_ENV;
export const DEBUGMODE = process.env.REACT_APP_DEBUG === 'true';
export const UPPSALA_FONTS_URL = 'https://static.uppsala.se/css/fonts/source-sans-pro/v21/source-sans-pro-v21.css';

export const AvailableOccasionsOffsetDays = 10;
export const RebookThresholdOffsetDays = 10;

export const days = ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'];
export const months = [
  'januari',
  'februari',
  'mars',
  'april',
  'maj',
  'juni',
  'juli',
  'augusti',
  'september',
  'oktober',
  'november',
  'december',
];

export const investigationOfImpedimentsLink =
  'https://www.uppsala.se/stod-och-omsorg/vigsel-och-begravning/container-formular/formular-borgerlig-vigsel/formular-for-att-ladda-upp-intyg/';

export const pinUserClaim = 'urn:oid:1.3.6.1.4.1.2428.90.1.5';

export const CUSTOM_OCCASION_VALUE = 'UPPSALA';

// Field length constants
export const DEFAULT_FIELD_MAX_LENGTH = 256;
export const EMAIL_FIELD_MAX_LENGTH = 256;
export const PHONE_FIELD_MAX_LENGTH = 24;
export const FIRSTNAME_FIELD_MAX_LENGTH = 128;
export const LASTNAME_FIELD_MAX_LENGTH = 128;
export const ADDRESS_FIELD_MAX_LENGTH = 128;
export const ZIPCODE_FIELD_MAX_LENGTH = 16;
export const CITY_FIELD_MAX_LENGTH = 128;
export const COUNTRY_FIELD_MAX_LENGTH = 128;

export const UPPSALA_KOMMUN_PHONE_NUMBER = '018-727 00 00';
